export var getColorOpcityList = function getColorOpcityList(prop, rgb) {
  var colorList = {};
  var i = 1;

  while (i <= 10) {
    var opcity = (i * 0.1).toFixed(1);

    var _props = "".concat(prop, "_").concat(i * 10);

    if (i === 10) {
      opcity = '1';
      _props = prop;
    }

    colorList[_props] = "rgba(".concat(rgb, ", ").concat(opcity, ")");
    i++;
  }

  return colorList;
};